/**
 * Constants related to the various states and routes within web register.
 */

/**
 * The [ui-router] states that can be navigated to in Web Register.
 *
 * @property STATES
 * @enum {String}
 */
export const STATES = {
  WEB_REGISTER: 'webregister',

  // ===== RESTRICTED ACCESS ===== //

  RESTRICTED_ACCESS: 'webregister.restricted',
  REGISTERS_UNAVAILABLE: 'webregister.restricted.registers-unavailable',
  DUPLICATE_WINDOW: 'webregister.restricted.duplicate-window',

  // ===== CURRENT SALE ===== //

  CURRENT_SALE: 'webregister.current-sale',
  SALE: 'webregister.current-sale.sale',
  PAYMENT_PANEL: 'webregister.current-sale.payment-panel',
  PAYMENT: 'webregister.current-sale.payment-panel.payment',
  SALE_CONFIRMATION: 'webregister.current-sale.payment-panel.sale-confirmation',

  // ===== REGISTER CLOSURE ===== //

  REGISTER_CLOSURE: 'webregister.register-closure',
  RESOLVE_REGISTER_CLOSURE_STATE:
    'webregister.register-closure.resolve-register-closure-state',
  CLOSE_REGISTER: 'webregister.register-closure.close-register',
  OPEN_REGISTER: 'webregister.register-closure.open-register',

  // ===== SALES HISTORY ===== //

  SALES_HISTORY: 'webregister.sales-history',

  // ===== STATUS ===== //

  STATUS: 'webregister.status',

  // ===== SETTINGS ===== //

  SETTINGS: 'webregister.settings',
  SETTINGS_QUICK_KEYS: 'webregister.settings.quickkeys',
  SETTINGS_QUICK_KEYS_EDIT: 'webregister.settings.quickkeys.edit',

  // ===== ERROR ===== //

  ERROR: 'error',
  ERROR_OFFLINE: 'error.offline',

  // ===== CASH MANAGEMENT ===== //

  CASH_MANAGEMENT: 'webregister.cash-management',

  // ===== API ===== //

  API_LOAD_SALE: 'load-sale',
  API_LOAD_QUOTE: 'load-quote',
}

/**
 * The URLs that exist in the Web Register application. Each route corresponds to a state by name but not all states
 * have a corresponding route.
 *
 * @property ROUTES
 * @enum {String}
 */

const ROUTES = {
  WEB_REGISTER: '/webregister',

  // ===== CURRENT SALE ===== //

  SALE: '/',
  SALE_CONFIRMATION: '/confirmation',

  // ===== REGISTER CLOSURE ===== //

  REGISTER_CLOSURE: '/registerclosure',

  // ===== SALES HISTORY ===== //

  SALES_HISTORY: '/history?customer_id&promo_code_id&promo_code',

  // ===== NEW SALES HISTORY (redirect to new service) ===== //

  NEW_SALES_HISTORY_ALL: '/sales/all',
  NEW_SALES_HISTORY_CONTINUE: '/sales/continue',
  NEW_SALES_HISTORY_REDIRECT: '/sales/redirect',

  // ===== STATUS ===== //

  STATUS: '/status',

  // ===== SETTINGS ===== //

  SETTINGS: '/settings',
  SETTINGS_QUICK_KEYS_ADD: '/quickkeys/add',

  // ===== ERROR ===== //

  ERROR_OFFLINE: '/error-offline',

  // ===== CASH MANAGEMENT ===== //

  CASH_MANAGEMENT: '/cash-management',

  // ===== API ===== //

  API_LOAD_SALE: '/sale/{sale:[a-zA-Z0-9-]+}?action&close_after_complete',

  API_LOAD_QUOTE: '/quote/{quoteId:[a-zA-Z0-9-]+}',
}

export { ROUTES }
